
      const gaId = import.meta.env.REACT_APP_GOOGLE_ANALYTICS_ID;
      if (gaId && document.location.host.search("localhost") === -1) {
        console.log("Using Google Analytics");
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://www.googletagmanager.com/gtag/js?id=" + gaId;
        document.head.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", gaId);
      } else {
        console.log("Not using Google Analytics");
      }
    